import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/rootReducer'
import { useShopData } from './shops/hooks/use-shop-data'

/**
 * ShopSession is kind of like the context, but not really.
 * We just need top level place to trigger some loads.
 */
export const ShopSession: React.FC<{}> = ({ children }) => {
  const currentShopID = useSelector<IRootReducerState, string>(state => state.auth.currentShop)
  const shopDataQuery = useShopData(currentShopID)

  useEffect(() => {
    // inject hotjar session when shop data is available
    if (shopDataQuery.data && 'hj' in window) {
      window.hj('tagRecording', [shopDataQuery.data.ID])
    }
  }, [shopDataQuery.data])

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}
